import createPropsHelper from '../../Core/Helpers/createPropsHelper'

export default createPropsHelper()
